import { history } from 'umi';
import type { ISkillData } from '../types';
import type { ISelectedSkillTagData } from '../../components/QAInput/SkillMention/SelectedSkillTag';
import { buildSelectedSkillTag } from './skillTag';
import { ChatTypes } from '../../ChatPage/types/chat';
import { store } from '../../ChatPage/hooks/useLocalState';

/**
 * 生成 Skill 详情页路径
 * @param skillId - Skill 唯一标识
 */
export const getSkillDetailPath = (skillId: string): string =>
  `/agent/skills/${encodeURIComponent(skillId)}`;

/** Skills 集列表页路径 */
export const SKILLS_COLLECTION_PATH = '/agent/skills';

/**
 * 当前页跳转 Skill 详情
 * @param skillId - Skill 唯一标识
 */
export const navigateToSkillDetail = (skillId: string): void => {
  history.push(getSkillDetailPath(skillId));
};

/**
 * 新标签页打开 Skill 详情页
 * @param skillId - Skill 唯一标识
 */
export const openSkillDetailInNewTab = (skillId: string): void => {
  window.open(getSkillDetailPath(skillId), '_blank');
};

/**
 * 切换详情页当前 Skill（推荐列表点击）
 * @param skillId - 目标 Skill 唯一标识
 */
export const replaceSkillDetail = (skillId: string): void => {
  history.replace(getSkillDetailPath(skillId));
};

/**
 * 返回 Skills 集列表页
 */
export const navigateToSkillsCollection = (): void => {
  history.push(SKILLS_COLLECTION_PATH);
};

/**
 * 跳转 Agent 首页并选中 Skill
 * @param skill - 目标 Skill
 * @param isEN - 是否英文环境
 */
export const navigateToHomeWithSkill = (
  skill: ISkillData,
  isEN: boolean,
): void => {
  store.setItem('__dba_copilot_tab__', ChatTypes.AI_CHAT);
  const selectedSkill: ISelectedSkillTagData = buildSelectedSkillTag(skill, isEN);
  history.push({
    pathname: '/agent/home',
    search: `?tab=${ChatTypes.AI_CHAT}`,
    state: { selectedSkill },
  });
};

/**
 * 跳转 Agent 首页并预填 Skill + 提问文案
 * @param skill - 目标 Skill
 * @param question - 预填提问内容
 * @param isEN - 是否英文环境
 */
export const navigateToHomeWithSkillAndQuestion = (
  skill: ISkillData,
  question: string,
  isEN: boolean,
): void => {
  store.setItem('__dba_copilot_tab__', ChatTypes.AI_CHAT);
  const selectedSkill: ISelectedSkillTagData = buildSelectedSkillTag(skill, isEN);
  history.push({
    pathname: '/agent/home',
    search: `?tab=${ChatTypes.AI_CHAT}`,
    state: {
      selectedSkill,
      initialQuestion: question,
    },
  });
};
